import { MutationTree } from 'vuex'

import { bus } from '@/main'

const mutations: MutationTree<any> = {
	'mutateCurrentStatementId'(state, payload) {
		state.currentStatementId = payload
	},
	'mutateChoices'(state, payload) {
		state.choices[payload.id] = payload.choice
		bus.$emit('goToStatement', payload.id + 2)
	},
	'mutateGraphSeen'(state, payload) {
		state.graphSeenOnStatement[payload] = true
	},
	'mutateResultsSeen'(state, payload) {
		state.resultsSeenSinceLastChange = payload
	},
	'mutateResultsSeenFirstTime'(state, payload) {
		state.resultsSeenSinceStart = payload
	}
}

export default mutations
